import Amex from '@/components/Icons/Amex.vue';
import CbsNews from '@/components/Icons/CbsNews.vue';
import Fox from '@/components/Icons/Fox.vue';
import Mastercard from '@/components/Icons/Mastercard.vue';
import Msn from '@/components/Icons/Msn.vue';
import Nbc from '@/components/Icons/Nbc.vue';
import Paypal from '@/components/Icons/Paypal.vue';
import Pbj from '@/components/Icons/Pbj.vue';
import Secure from '@/components/Icons/Secure.vue';
import Visa from '@/components/Icons/Visa.vue';

import Coins from '@/components/Icons/credits/Coins.vue';
import Handshake from '@/components/Icons/credits/Handshake.vue';
import Heart from '@/components/Icons/credits/Heart.vue';

import Sparkle from '@/components/Icons/Sparkle.vue';
import Sparkles from '@/components/Icons/Sparkles.vue';

import AmpifireVerified from '@/components/Icons/AmpifireVerified.vue';
import Verified from '@/components/Icons/Verified.vue';
import ColorSwatch from '@/components/Icons/ColorSwatch.vue';

import ApNewsLogo from '@/components/Icons/sites/ApNews.vue';
import ApplePodcastLogo from '@/components/Icons/sites/ApplePodcast.vue';
import BenzingaLogo from '@/components/Icons/sites/Benzinga.vue';
import BusinessInsiderLogo from '@/components/Icons/sites/BusinessInsider.vue';
import DigitalJournalLogo from '@/components/Icons/sites/DigitalJournal.vue';
import FoxLogo from '@/components/Icons/sites/Fox.vue';
import GoogleNewsLogo from '@/components/Icons/sites/GoogleNews.vue';
import MediumLogo from '@/components/Icons/sites/Medium.vue';
import MsnLogo from '@/components/Icons/sites/Msn.vue';
import PinterestLogo from '@/components/Icons/sites/Pinterest.vue';
import SpotifyLogo from '@/components/Icons/sites/Spotify.vue';
import TheStreetLogo from '@/components/Icons/sites/TheStreet.vue';
import UsaTodayLogo from '@/components/Icons/sites/UsaToday.vue';
import YahooLogo from '@/components/Icons/sites/Yahoo.vue';
import YoutubeLogo from '@/components/Icons/sites/Youtube.vue';
import StreetInsiderLogo from '@/components/Icons/sites/StreetInsider.vue';
// colorful icons
import ApNewsColorLogo from '@/components/Icons/sites/color/ApNews.vue';
import ApplePodcastColorLogo from '@/components/Icons/sites/color/ApplePodcast.vue';
import BenzingaColorLogo from '@/components/Icons/sites/color/Benzinga.vue';
import BusinessInsiderColorLogo from '@/components/Icons/sites/color/BusinessInsider.vue';
import DigitalJournalColorLogo from '@/components/Icons/sites/color/DigitalJournal.vue';
import FoxColorLogo from '@/components/Icons/sites/color/Fox.vue';
import GoogleNewsColorLogo from '@/components/Icons/sites/color/GoogleNews.vue';
import MediumColorLogo from '@/components/Icons/sites/color/Medium.vue';
import MsnColorLogo from '@/components/Icons/sites/color/Msn.vue';
import PinterestColorLogo from '@/components/Icons/sites/color/Pinterest.vue';
import SpotifyColorLogo from '@/components/Icons/sites/color/Spotify.vue';
import TheStreetColorLogo from '@/components/Icons/sites/color/TheStreet.vue';
import UsaTodayColorLogo from '@/components/Icons/sites/color/UsaToday.vue';
import YahooColorLogo from '@/components/Icons/sites/color/Yahoo.vue';
import YoutubeColorLogo from '@/components/Icons/sites/color/Youtube.vue';
import StreetInsiderColorLogo from '@/components/Icons/sites/color/StreetInsider.vue';

export default {
    visa: {
        component: Visa
    },
    amex: {
        component: Amex
    },
    mastercard: {
        component: Mastercard
    },
    paypal: {
        component: Paypal
    },
    secure: {
        component: Secure
    },
    msn: {
        component: Msn
    },
    cbsnews: {
        component: CbsNews
    },
    fox: {
        component: Fox
    },
    nbc: {
        component: Nbc
    },
    pbj: {
        component: Pbj
    },
    coins: {
        component: Coins
    },
    heart: {
        component: Heart
    },
    handshake: {
        component: Handshake
    },
    sparkle: {
        component: Sparkle
    },
    sparkles: {
        component: Sparkles
    },
    verified: {
        component: Verified
    },
    AmpifireVerified: {
        component: AmpifireVerified
    },
    ColorSwatch: {
        component: ColorSwatch
    },
    // TrustBadge site logos
    ApplePodcastLogo: {
        component: ApplePodcastLogo
    },
    BenzingaLogo: {
        component: BenzingaLogo
    },
    BusinessInsiderLogo: {
        component: BusinessInsiderLogo
    },
    DigitalJournalLogo: {
        component: DigitalJournalLogo
    },
    FoxLogo: {
        component: FoxLogo
    },
    GoogleNewsLogo: {
        component: GoogleNewsLogo
    },
    MediumLogo: {
        component: MediumLogo
    },
    MsnLogo: {
        component: MsnLogo
    },
    PinterestLogo: {
        component: PinterestLogo
    },
    SpotifyLogo: {
        component: SpotifyLogo
    },
    UsaTodayLogo: {
        component: UsaTodayLogo
    },
    YahooLogo: {
        component: YahooLogo
    },
    YoutubeLogo: {
        component: YoutubeLogo
    },
    TheStreetLogo: {
        component: TheStreetLogo
    },
    ApNewsLogo: {
        component: ApNewsLogo
    },
    StreetInsiderLogo: {
        component: StreetInsiderLogo
    },
    ApplePodcastColorLogo: {
        component: ApplePodcastColorLogo
    },
    BenzingaColorLogo: {
        component: BenzingaColorLogo
    },
    BusinessInsiderColorLogo: {
        component: BusinessInsiderColorLogo
    },
    DigitalJournalColorLogo: {
        component: DigitalJournalColorLogo
    },
    FoxColorLogo: {
        component: FoxColorLogo
    },
    GoogleNewsColorLogo: {
        component: GoogleNewsColorLogo
    },
    MediumColorLogo: {
        component: MediumColorLogo
    },
    MsnColorLogo: {
        component: MsnColorLogo
    },
    PinterestColorLogo: {
        component: PinterestColorLogo
    },
    SpotifyColorLogo: {
        component: SpotifyColorLogo
    },
    UsaTodayColorLogo: {
        component: UsaTodayColorLogo
    },
    YahooColorLogo: {
        component: YahooColorLogo
    },
    YoutubeColorLogo: {
        component: YoutubeColorLogo
    },
    TheStreetColorLogo: {
        component: TheStreetColorLogo
    },
    ApNewsColorLogo: {
        component: ApNewsColorLogo
    },
    StreetInsiderColorLogo: {
        component: StreetInsiderColorLogo
    }
};
